import styled from '@emotion/styled';
import { Stack, colors } from '@ui-components/neo.tax';

import { NAV_HEIGHT } from '@neo.tax/shared';

export const Container = styled(Stack)({
  backgroundColor: colors.gray[100],
  height: `calc(100vh - ${NAV_HEIGHT}px)`,
});
